<ng-template>
  <section class="bs o3-overlay--container"
    [csTestId]="config.id"
    cdkDrag
    [cdkDragFreeDragPosition]="dragPosition"
    [cdkDragConstrainPosition]="dragConstrainFn"
    [cdkDragDisabled]="!config.isDraggable"
    [cdkDragRootElement]="overlayId"
    [ngClass]="config.overlayClass"
    [@.disabled]="!config.isAnimationsEnabled"
    (@transformDropdown.done)="onAnimationDone()"
    (@transformDialog.done)="onAnimationDone()"
    [@transformDropdown]="{value: overlayOrigin ? animationState : 'none'}"
             [@transformDialog]="{value: !overlayOrigin ? animationState : 'none',
                                  params: {voidTransform: dialogVoidTransform, leaveTransform: dialogLeaveTransform}}">
    <div class="o3-overlay--content-container"
      [class.o3-overlay--dropdown-container]="!!overlayOrigin"
      [style.border-radius.px]="config.borderRadius"
      [ngClass]="config.containerClasses"
      [cdkTrapFocus]="trapFocus"
      [cdkTrapFocusAutoCapture]="trapFocus">
      <div class="o3-overlay--dialog-drag o3-overlay--for-shadow"></div> <!-- for use when handle is placed outside main overlay -->
      @if (config.isDraggable) {
        <div class="o3-overlay--dialog-drag"
          cdkDragHandle
          (mousedown)="setDragConstraints($event)">
          <mat-icon>drag_handle</mat-icon>
        </div>
      }
      <ng-content></ng-content>
      <ng-template [cdkPortalOutlet]="portal"></ng-template>
    </div>
    @if (config.showCloseButton) {
      <div class="o3-overlay--dialog-close"
        #test_close
        >
        <cs-icon-button buttonStyle="tertiary"
          csIcon="cs-icon-close-circle"
          (buttonClick)="closeOverlay()"/>
      </div>
    }
  </section>
</ng-template>
